import ApiService from './ApiService'

const api = ApiService

export const getAll = ({ token, locale }) => {
  return api.get('/translations', { locale }, { headers: { Authorization: `Bearer ${token}` } })
}
